var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import noop from 'lodash/noop';
import { createRef, Fragment, PureComponent, } from 'react';
import styles from './fieldRepeater.module.scss';
import { RepeaterDivider } from './repeaterDivider';
const DEFAULT_BUTTON_PROPS = {
    className: '',
    label: '+ Add',
    placement: 'top',
};
export class FieldRepeater extends PureComponent {
    get buttonProps() {
        const { buttonProps } = this.props;
        return buttonProps
            ? Object.assign(Object.assign({}, DEFAULT_BUTTON_PROPS), buttonProps) : DEFAULT_BUTTON_PROPS;
    }
    constructor(props) {
        super(props);
        this.rowsRef = createRef();
        this.handleAddClick = this.handleAddClick.bind(this);
    }
    componentDidMount() {
        this.props.onMount();
    }
    componentDidUpdate(prevProps) {
        const { fields } = this.props;
        if (fields.length > prevProps.fields.length && this.rowsRef.current) {
            const childCount = this.rowsRef.current.childNodes.length;
            const lastElement = this.rowsRef.current.childNodes[childCount - 1];
            if (lastElement instanceof HTMLElement) {
                lastElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
    handleAddClick() {
        const { defaultRowProps, fields, onAddRow } = this.props;
        onAddRow();
        fields.push(typeof defaultRowProps === 'function'
            ? defaultRowProps()
            : defaultRowProps);
    }
    render() {
        const _a = this.props, { buttonProps, className, defaultRowProps, rowComponent: RowComponent, title, fields, meta, actions: Actions, divider, rowProps, style, withBackground, onAddRow, onMount } = _a, otherProps = __rest(_a, ["buttonProps", "className", "defaultRowProps", "rowComponent", "title", "fields", "meta", "actions", "divider", "rowProps", "style", "withBackground", "onAddRow", "onMount"]);
        const rootClass = classnames({
            [styles.withBackground]: withBackground,
        }, className);
        const { className: buttonClassName, label: buttonLabel, placement: buttonPlacement, } = this.buttonProps;
        const shouldRenderHeader = buttonPlacement === 'top' || !!title;
        return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [shouldRenderHeader && (_jsxs("div", Object.assign({ className: styles.header }, { children: [typeof title === 'string' ? (_jsx("h2", Object.assign({ className: styles.title }, { children: title }))) : (title), buttonPlacement === 'top' && (_jsxs("div", Object.assign({ className: styles.actions }, { children: [!!Actions && _jsx(Actions, { fields: fields, meta: meta }), _jsx("button", Object.assign({ type: "button", className: classnames(styles.action, buttonClassName), onClick: this.handleAddClick }, { children: buttonLabel }))] })))] }))), !meta.pristine && meta.error && (_jsx("div", Object.assign({ className: styles.error }, { children: meta.error }))), fields.length > 0 && (_jsxs("div", Object.assign({ className: styles.rows, style: style || {}, ref: this.rowsRef }, { children: [fields.map((field, index) => (_jsxs(Fragment, { children: [_jsx(RowComponent, Object.assign({}, rowProps, { field: field, index: index, meta: meta, onRemove: fields.remove, totalRows: fields.length })), index < fields.length - 1 && !!divider && divider] }, field))), buttonPlacement === 'bottom' && (_jsxs(_Fragment, { children: [_jsx(RepeaterDivider, {}), _jsx(Button, Object.assign({ className: classnames(styles.addButton, buttonClassName), onClick: this.handleAddClick, variant: "secondary" }, { children: buttonLabel }))] }))] })))] })), buttonPlacement === 'outside' && (_jsx(Button, Object.assign({ className: classnames(styles.addButton, buttonClassName), onClick: this.handleAddClick, variant: "secondary" }, { children: buttonLabel })))] }));
    }
}
FieldRepeater.defaultProps = {
    defaultRowProps: {},
    rowProps: {},
    onAddRow: noop,
    onMount: noop,
    withBackground: true,
};
